import '../styles/HomeUseCases.scss';
import {Row, Col} from 'react-simple-flex-grid';
import {useInView} from "react-intersection-observer";

export const HomeUseCasesBlock = () => {
    const [ref, inView] = useInView({
        triggerOnce: true,
        threshold: 0.5
    })

    return <>
        <div ref={ref} className={inView ? 'use-cases-wrapper slideInUp' : 'use-cases-wrapper' }>
            <div className="section-shadow section-shadow-from-top"></div>
            <div className="section-header">
                <h2 className="block-title">usecases</h2>
                <h3 className="block-subtitle">
                    Technologies used in the solution can be applied to solve various problems in different industries.
                </h3>
            </div>
            <div className="cards-container">
                <Row align="bottom">
                    <Col xs={12} sm={4}>
                        <div className="card card-first">
                            <h4 className="card-title">
                                Customer engagement
                            </h4>
                            <p className="card-description">
                                Photorealistic Digital Assistant can be used at the store to perform some repeatable
                                tasks, such
                                as educating the customers in engaging way about the products and its features.
                            </p>
                        </div>
                    </Col>
                    <Col xs={12} sm={4}>
                        <div className="card card-second">
                            <h4 className="card-title">
                                Immersive education
                            </h4>
                            <p className="card-description">
                                Through creating tech-driven immersive experiences, we can help businesses to engage
                                better with their customers and so, increase brand loyalty.
                            </p>
                        </div>
                    </Col>
                    <Col xs={12} sm={4}>
                        <div className="card card-third">
                            <h4 className="card-title">
                                Brand awareness
                            </h4>
                            <p className="card-description">
                                Using the mixture of cutting-edge and mature technologies, SoftServe can build
                                outstanding experiences for the clients to stand out attracting visitors and media at
                                industry or brand conferences.
                            </p>
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="section-shadow section-shadow-from-bottom"></div>
        </div>
    </>
}